export default "/_next/static/videos/0345883b281d6a66edb2a16b72a2757c.mp4";